// utils/v3/time.ts — token expiry + display helpers (SPEC §6)
// Ports legacy `utils/checkExpireDate.ts` (getEndTimeDayjs) and the
// `displayTime` helper of `components/Guests/Menu.vue`.
import dayjs from 'dayjs'
import type { QrToken } from '~/types/v3/token'

export type ExpiringToken = Pick<QrToken, 'createdAt'> & { length?: number }

/**
 * Epoch ms at which the token expires, or null when the session is unlimited
 * (`length` 0 / undefined — legacy only enforces expiry when `length > 0`).
 */
export function tokenExpiresAt(token: ExpiringToken | null | undefined): number | null {
  if (!token) return null
  const length = Number(token.length) || 0
  if (length <= 0) return null
  return dayjs(token.createdAt).add(length, 'minute').valueOf()
}

/** Legacy: `dayjs().isAfter(end) && length > 0` — strictly after the end time. */
export function isTokenExpired(token: ExpiringToken | null | undefined, now: number = Date.now()): boolean {
  const expiresAt = tokenExpiresAt(token)
  if (expiresAt === null) return false
  return now > expiresAt
}

/**
 * Home-card time formatting. Legacy `displayTime` renders `DD/MMM HH:mm`,
 * which stays the default; pass a format string for a shorter label.
 */
export function formatTime(iso: string | null | undefined, format = 'DD/MMM HH:mm'): string {
  if (!iso) return ''
  const d = dayjs(iso)
  return d.isValid() ? d.format(format) : ''
}
